module.exports = __webpack_public_path__ + "images/emoji/baby_chick.cde2e44e8236718382dd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/baby_chick.png
// module id = T6IZ
// module chunks = 14